import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { SerieProposalItemEffects } from './serie-proposal-item.effects'
import * as fromSerieProposalItem from './serie-proposal-item.reducer'
import { SerieProposalItemSerializer } from './serie-proposal-item.serializer'
import { SerieProposalItemService } from './serie-proposal-item.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromSerieProposalItem.FEATURE_NAME,
      fromSerieProposalItem.serieProposalItemReducer
    ),
    EffectsModule.forFeature([SerieProposalItemEffects])
  ],
  declarations: [],
  exports: [],
  providers: [
    SerieProposalItemService,
    {
      provide: SerieProposalItemSerializer,
      useClass: SerieProposalItemSerializer
    }
  ]
})
export class SerieProposalItemModule {}
